import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const IqosLoadable = Loadable({
    loader: (): any => import('./Iqos').then((res) => res.Iqos),
    loading: <Loader/>,
});
